import { useEffect, useState, useRef } from "react";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import HeaderWhite from "../Components/Header/HeaderWhite";
import { businessPages } from "../actions/ApiCalls";
import './app.css';
import {IMAGE_URL} from "../path";

function Vision() {
    const [data, setData] = useState<any[]>([]);
    const [isMobile, setIsMobile] = useState<boolean>(false);
    const [isAtTop, setIsAtTop] = useState(true);
    const publicUrl = IMAGE_URL;

    const firstTextRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        document.title = "Vinimark | Our Vision";

        const handleResize = () => {
            setIsMobile(window.innerWidth <= 575);
        };

        const handleScroll = () => {
            setIsAtTop(window.scrollY === 0);
        };

        handleResize();
        handleScroll();

        window.addEventListener("resize", handleResize);
        window.addEventListener("scroll", handleScroll);

        businessPages(2)
            .then(response => {
                setData(response.data);
            })
            .catch(error => {
                console.error("Failed to fetch business pages:", error);
            });

        return () => {
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const linkStyle: React.CSSProperties = {
        color: 'white',
        fontSize: '10px',
        fontFamily: "'Vinimark-Diatype', sans-serif",
        fontWeight: 600,
        textTransform: 'uppercase',
        textDecoration: 'underline',
        textUnderlineOffset: '2px',
        cursor: 'pointer',
        lineHeight: '13px'
    };

    const scrollToTextSection = () => {
        if (firstTextRef.current) {
            const yOffset = -100; // offset 50px above
            const y = firstTextRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: "smooth" });
        }
    };

    let foundFirstTextSection = false;
    let foundFirstImageSection = false;

    const lastTextIndex = [...data]
        .reverse()
        .findIndex(page => !page.image);

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative'
        }}>
            {isAtTop ? <HeaderWhite /> : <Header />}
            <div style={{ flex: '1' }}>
                <div className="our-story-container">
                    {data.map((page, index) => {

                        const imageUrl = `${publicUrl}${isMobile ? page.mobile_image : page.image}`.replace(/ /g, '%20');
                        const isTextSection = !page.image;
                        const assignRef = isTextSection && !foundFirstTextSection;

                        if (assignRef) foundFirstTextSection = true;


                        const trueLastTextIndex = lastTextIndex >= 0 ? data.length - 1 - lastTextIndex : -1;

                        const isFirstImageWithTitle = page.image && page.title && !foundFirstImageSection;
                        if (isFirstImageWithTitle) foundFirstImageSection = true;
                        const isLastTextSection = index === trueLastTextIndex;

                        return (
                            <div key={index}>
                                {page.image ? (
                                        page.title ? (
                                            <>
                                                {isFirstImageWithTitle && (
                                                    <div
                                                        style={{
                                                            backgroundImage: `url(${imageUrl})`,
                                                            width: '100vw',
                                                            height: window.innerWidth > 835 ? '100vh' : '90vh',
                                                            backgroundSize: 'cover',
                                                            backgroundPosition: 'center',
                                                            display: 'flex',
                                                            alignItems: 'flex-start',
                                                            marginBottom: '80px'
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                position: window.innerWidth > 768 ? 'relative' : 'static',
                                                                left: window.innerWidth > 768 ? '50%' : 'auto',
                                                                marginTop: '140px',
                                                                width: window.innerWidth > 768 ? '50%' : '80%',
                                                                textAlign: 'left',
                                                                color: 'white',
                                                                fontFamily: "'Vinimark-Diatype', sans-serif",
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                height: window.innerWidth > 835 ? '90%' : '70%',
                                                                justifyContent: 'flex-end',
                                                                marginBottom: '80px'
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    fontSize: '32px',
                                                                    fontWeight: 200,
                                                                    textTransform: "uppercase",
                                                                    marginBottom: '10px',
                                                                    paddingLeft: window.innerWidth > 835 ? '0' : '20px',
                                                                    marginLeft: window.innerWidth > 835 ? '26px' : 0,
                                                                    lineHeight: '32px',
                                                                }}
                                                            >
                                                                {page.title}
                                                            </div>
                                                            <a
                                                                onClick={scrollToTextSection}
                                                                style={{
                                                                    color: 'white',
                                                                    fontSize: '10px',
                                                                    lineHeight: '16.9px',
                                                                    marginBottom: window.innerWidth > 835 ? '112px' : '30px',
                                                                    cursor: 'pointer',
                                                                    textDecoration: 'underline',
                                                                    textUnderlineOffset: '2px',
                                                                    display: 'inline-block',
                                                                    textTransform: 'uppercase',
                                                                    fontWeight: 600,
                                                                    marginLeft: '26px',
                                                                }}
                                                            >
                                                                Read more
                                                            </a>
                                                        </div>
                                                    </div>
                                                )}

                                                {!isFirstImageWithTitle && (
                                                    <img
                                                        src={imageUrl}
                                                        alt="Business Page"
                                                        className={page.is_full ? "our-story-image-full" : "our-story-image-centered"}
                                                    />
                                                )}

                                            </>
                                        ) : (
                                            <img
                                                src={imageUrl}
                                                alt="Business Page"
                                                className={page.is_full ? "our-story-image-full" : "our-story-image-centered"}
                                            />
                                        )
                                    ) : (
                                    <div
                                        className={`our-story-text-section-wrapper`}
                                        ref={assignRef ? firstTextRef : undefined}
                                    >
                                        <div className={`our-story-text-section ${isMobile ? "mobile" : ""}`} >
                                            <div className="our-story-text-block-left" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignContent: 'flex-start', width: '100%', marginBottom: '20px' }}>
                                                <div style={{
                                                    width: isMobile ? '100%' : '70%',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'flex-start',
                                                    alignItems: isMobile ? 'flex-start' : 'flex-end',
                                                    padding: 0,
                                                    margin: 0,
                                                }}>
                                                    <div
                                                        style={{
                                                            fontSize: '20px',
                                                            textAlign: isMobile ? 'left' : 'right',
                                                            width: '100%',
                                                            marginRight: isMobile ? 0 : '72px',
                                                            marginTop: 0,
                                                            padding: 0,
                                                        }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: (page.left_text || "").replace(/<p>/g, '<p style="margin-top: 0; font-weight: 300; font-size: 13px">')
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <div className="our-story-text-block">
                                                <div
                                                    style={{
                                                        width: isMobile ? '90%' : '70%',
                                                        marginTop: 0,
                                                        marginLeft: isMobile ? '0px' : '24px',
                                                    }}
                                                    dangerouslySetInnerHTML={{
                                                        __html: ((): any => {
                                                            const rightText = page.right_text || '';
                                                            const styledRightText = rightText.replace(/<p>/g, '<p style="font-weight: 400; margin-top: 0; font-size: 13px">');
                                                            return `${page.title ? `<h2 class="our-story-title" style="font-weight: 600">${page.title}</h2>` : ''}${styledRightText}`;
                                                        })()
                                                    }}

                                                />
                                                {isLastTextSection && (
                                                    <div style={{ marginBottom: '30px', marginLeft: isMobile ? '0px' : '24px' }} className="read-more">
                                                        <p style={{fontSize: '13px', lineHeight: '16.9px'}}>READ ON: <a style={{lineHeight: '16.9px', fontSize: '13px'}} href={'/about/our-approach'}>OUR APPROACH</a></p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Vision;
